import React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";

import { withAuth } from '../../../context';
import { Dialog } from '@material-ui/core';

const Wrapper = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  position: fixed;
  left: 0;
  top: 50%;
  width: 32px;
  z-index: 999;
  background-color: rgb(255, 255, 255);
  box-shadow: 1px 2px 5px 0px rgba(0, 0, 0, 0.41);

  cursor: pointer;
`;

const ListItem = styled.li`
  flex: 1;
  padding: 1px 0;
  border-right: solid 1px #dfdfdf;

  img {
    width: 100%;
    border-bottom: solid 1px #dfdfdf;
  }
`;

const MobileNavBar = ({ auth }) => {
  const [isWechatQrCodeOpen, setIsWechatQrCodeOpen] = React.useState();

  const onWechatQrCodeClick = React.useCallback(() => {
    setIsWechatQrCodeOpen(true);
  }, [setIsWechatQrCodeOpen]);

  const onWechatQrCodeClose = React.useCallback(() => {
    setIsWechatQrCodeOpen(false);
  }, [setIsWechatQrCodeOpen]);

  return (
    <Wrapper>
      <ListItem onClick={onWechatQrCodeClick}>
        <img src="/images/footer/footer_wechat.png" alt="" />
      </ListItem>
      <ListItem>
        <a href="http://weibo.com/lamychinahk" target="_blank" rel="noopener noreferrer">
          <img src="/images/footer/footer_weibo.png" alt="" />
        </a>
      </ListItem>
      <ListItem>
        <a href="https://lamy.tmall.com" target="_blank" rel="noopener noreferrer">
          <img src="/images/footer/footer_tmall.png" alt="" />
        </a>
      </ListItem>
      <ListItem>
        <a href="mailto:cs@lamy.com.hk">
          <img src="/images/footer/footer_email.png" alt="" />
        </a>
      </ListItem>

      <Dialog open={isWechatQrCodeOpen} onClose={onWechatQrCodeClose}>
        <img src="/images/footer/lamy_wechatQR.png" alt="" />
      </Dialog>
    </Wrapper>
  );
}

export default React.memo(
  withAuth(
    MobileNavBar
  )
);